var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMevuelo = function SvgMevuelo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 65,
    viewBox: "0 0 202 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.952 48.8804L154.512 54.8076L154.854 54.9485L157.294 49.0213L156.952 48.8804Z",
    fill: "url(#paint0_linear_1094_27939)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.436 48.4456L156.957 57.0586L157.323 57.1215L158.802 48.5085L158.436 48.4456Z",
    fill: "url(#paint1_linear_1094_27939)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.352 49.5991L159.984 49.6445L160.771 56.0061L161.138 55.9607L160.352 49.5991Z",
    fill: "url(#paint2_linear_1094_27939)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.782 64.3098L152.642 63.2198L152.512 54.5098L162.942 55.6298L160.782 64.3098Z",
    fill: "url(#paint3_linear_1094_27939)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.729 45.72C160.529 46.08 161.249 46.03 161.949 44.84C165.399 38.99 168.879 33.15 171.259 26.76C173.709 20.19 174.869 13.42 173.769 6.4C173.609 5.4 173.279 4.4 173.029 3.4C175.029 3.65 178.029 6.13 178.589 8.02C179.55 11.6169 179.608 15.3952 178.759 19.02C177.311 26.2241 173.99 32.9192 169.129 38.43L162.619 45.93L163.619 46.03C162.899 47.31 162.229 48.55 161.499 49.75C161.413 49.8683 161.302 49.9663 161.174 50.0371C161.047 50.1079 160.905 50.1499 160.759 50.16C159.622 50.1456 158.49 50.0183 157.379 49.78C157.07 49.6789 156.787 49.5122 156.549 49.2912C156.31 49.0703 156.123 48.8003 155.999 48.5C155.159 43.5 152.789 38.99 151.239 34.23C148.528 26.4438 148.28 18.012 150.529 10.08C151.354 7.20438 152.817 4.55188 154.809 2.32C155.138 1.90794 155.547 1.56633 156.01 1.3155C156.474 1.06468 156.984 0.909766 157.509 0.86L161.279 0.5C156.519 5.86 154.929 12.28 154.079 18.93C152.999 27.39 154.559 35.7 155.939 44C156.039 44.58 156.999 45 157.569 45.53L157.959 45.32C158.079 43.56 158.209 41.81 158.329 40.05C159.019 30.05 159.549 20.05 161.899 10.24C162.599 7.36 163.739 4.59 164.689 1.77C164.949 1.01 165.459 0.84 166.279 1.01C169.179 1.58 169.429 1.63 169.159 4.72C168.92 8.72638 168.372 12.7083 167.519 16.63C165.109 26.34 162.359 35.97 159.729 45.72ZM142.879 18.72C142.879 25 145.879 30.08 149.449 34.92C144.799 25.77 143.119 16.42 147.389 6.62C144.522 9.98911 142.926 14.2564 142.879 18.68V18.72ZM171.999 38.24C173.228 37.3386 174.41 36.374 175.539 35.35C179.149 32.07 182.479 28.56 184.029 23.77C185.108 20.382 184.858 16.7102 183.329 13.5C183.909 23.72 178.909 31.41 171.999 38.24Z",
    fill: "url(#paint4_linear_1094_27939)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33 44.82V46.82H3.41C3.90769 46.0262 4.60405 45.3761 5.43015 44.9341C6.25625 44.4922 7.18346 44.2736 8.12 44.3C9.23962 44.2873 10.3418 44.5775 11.31 45.14C12.2435 45.6796 13.0113 46.4647 13.53 47.41C14.0908 46.4001 14.9549 45.592 16 45.1C17.0666 44.5633 18.246 44.289 19.44 44.3C23.6 44.3 25.68 46.9233 25.68 52.17V64.31H22.32V52.69C22.32 51.92 22.32 51.28 22.24 50.77C22.163 50.1961 22.0222 49.6326 21.82 49.09C21.6262 48.5154 21.2369 48.027 20.72 47.71C20.1065 47.3804 19.4158 47.2215 18.72 47.25C17.9258 47.2202 17.1392 47.4143 16.45 47.81C15.8532 48.1841 15.399 48.7474 15.16 49.41C14.9121 50.0565 14.7312 50.7266 14.62 51.41C14.5127 52.1517 14.4625 52.9006 14.47 53.65V64.31H11.16V52.93C11.16 49.15 10 47.25 7.66 47.25C6.84831 47.2236 6.04623 47.4319 5.35 47.85C4.72831 48.2337 4.25304 48.8146 4 49.5C3.74224 50.1708 3.56109 50.8685 3.46 51.58C3.3535 52.3352 3.30336 53.0973 3.31 53.86V64.31H0V44.82H3.33Z",
    fill: "url(#paint5_linear_1094_27939)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9984 55.0798H33.6484C33.6513 56.7368 34.3091 58.3256 35.4784 59.4998C36.0757 60.1016 36.7907 60.5738 37.5787 60.8869C38.3668 61.2 39.2109 61.3474 40.0584 61.3198C42.525 61.3198 44.525 60.0264 46.0584 57.4398L48.8884 58.9998C48.0478 60.6457 46.7536 62.0166 45.1588 62.9505C43.5639 63.8843 41.7351 64.3421 39.8884 64.2698C38.59 64.3343 37.2928 64.1206 36.0838 63.6428C34.8748 63.1651 33.7819 62.4344 32.8784 61.4998C32.004 60.5808 31.3198 59.4982 30.865 58.3141C30.4102 57.13 30.1939 55.8677 30.2284 54.5998C30.1416 51.9509 31.0475 49.3653 32.7684 47.3498C33.6464 46.3773 34.7305 45.6132 35.9416 45.1132C37.1526 44.6132 38.46 44.39 39.7684 44.4598C41.0951 44.3949 42.4186 44.6405 43.6338 45.1769C44.849 45.7133 45.9222 46.5258 46.7684 47.5498C48.4474 49.6821 49.2455 52.3769 48.9984 55.0798ZM33.7984 52.3698H45.4984C45.2767 50.9997 44.5662 49.7563 43.4984 48.8698C42.4638 47.9733 41.1372 47.486 39.7684 47.4998C38.3348 47.4973 36.9478 48.0081 35.8584 48.9398C34.763 49.7786 34.0325 51.0068 33.8184 52.3698H33.7984Z",
    fill: "url(#paint6_linear_1094_27939)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2587 44.2998L60.0887 56.9198L65.9187 44.2998H69.6687L60.0887 64.2998L50.4688 44.2998H54.2587Z",
    fill: "url(#paint7_linear_1094_27939)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9997 44.3096V55.4996C75.9997 56.2196 75.9997 56.8396 76.0597 57.3396C76.1098 57.8779 76.2239 58.4083 76.3997 58.9196C76.5433 59.4078 76.7925 59.8584 77.1297 60.2396C77.4914 60.6078 77.9327 60.8883 78.4197 61.0596C79.7185 61.4883 81.1208 61.4883 82.4197 61.0596C82.9084 60.8859 83.3525 60.6059 83.7197 60.2396C84.0499 59.8552 84.2953 59.4053 84.4397 58.9196C84.6154 58.4083 84.7296 57.8779 84.7797 57.3396C84.7797 56.8396 84.8397 56.2196 84.8397 55.4996V44.3096H88.1697V55.8396C88.1697 61.4862 85.5897 64.3096 80.4297 64.3096C75.2697 64.3096 72.6864 61.4862 72.6797 55.8396V44.3096H75.9997Z",
    fill: "url(#paint8_linear_1094_27939)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.229 55.0803H95.8695C95.8688 55.9012 96.0301 56.7141 96.3441 57.4726C96.6581 58.2311 97.1187 58.9201 97.6995 59.5003C98.2961 60.1031 99.011 60.5759 99.7992 60.8891C100.587 61.2023 101.432 61.3491 102.279 61.3203C104.746 61.3203 106.746 60.0269 108.279 57.4403L111.109 59.0003C110.268 60.6454 108.974 62.0156 107.379 62.9494C105.784 63.8831 103.956 64.3414 102.109 64.2703C100.811 64.3348 99.514 64.1211 98.3049 63.6433C97.0959 63.1656 96.003 62.4349 95.0995 61.5003C94.2233 60.5826 93.5379 59.5003 93.083 58.3158C92.6281 57.1314 92.4128 55.8685 92.4495 54.6003C92.3756 51.9638 93.2845 49.394 94.9995 47.3903C95.8767 46.4167 96.9606 45.6518 98.1719 45.1518C99.3832 44.6517 100.691 44.4291 101.999 44.5003C103.326 44.437 104.649 44.6833 105.864 45.2196C107.079 45.7559 108.152 46.5675 108.999 47.5903C110.673 49.7099 111.471 52.3903 111.229 55.0803ZM95.9995 52.3703H107.709C107.484 51.0017 106.774 49.7597 105.709 48.8703C104.68 47.9784 103.361 47.4914 101.999 47.5003C100.563 47.4954 99.1716 48.0064 98.0795 48.9403C96.9753 49.7776 96.2315 51.0041 95.9995 52.3703Z",
    fill: "url(#paint9_linear_1094_27939)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.06 31.3496V64.3496H115.73V31.3496H119.06Z",
    fill: "url(#paint10_linear_1094_27939)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.091 61.44C139.113 63.2846 136.51 64.3104 133.806 64.3104C131.102 64.3104 128.498 63.2846 126.521 61.44C125.556 60.5499 124.791 59.4663 124.274 58.2601C123.757 57.0539 123.5 55.7522 123.521 54.44C123.5 53.119 123.756 51.8083 124.273 50.5923C124.79 49.3763 125.555 48.2821 126.521 47.38C128.492 45.5244 131.098 44.4912 133.806 44.4912C136.513 44.4912 139.119 45.5244 141.091 47.38C142.056 48.2821 142.822 49.3763 143.338 50.5923C143.855 51.8083 144.111 53.119 144.091 54.44C144.111 55.7522 143.854 57.0539 143.337 58.2601C142.82 59.4663 142.055 60.5499 141.091 61.44ZM138.801 49.5C137.46 48.2024 135.667 47.4769 133.801 47.4769C131.935 47.4769 130.142 48.2024 128.801 49.5C127.541 50.8345 126.84 52.6001 126.84 54.435C126.84 56.27 127.541 58.0356 128.801 59.37C130.142 60.6677 131.935 61.3932 133.801 61.3932C135.667 61.3932 137.46 60.6677 138.801 59.37C140.06 58.0356 140.762 56.27 140.762 54.435C140.762 52.6001 140.06 50.8345 138.801 49.5Z",
    fill: "url(#paint11_linear_1094_27939)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.69 55.5V57.58C175.349 57.1021 174.899 56.7123 174.377 56.4428C173.856 56.1733 173.277 56.0318 172.69 56.03C172.244 56.019 171.8 56.1023 171.388 56.2747C170.976 56.447 170.606 56.7044 170.3 57.03C169.991 57.3495 169.748 57.7268 169.585 58.1404C169.422 58.5539 169.342 58.9955 169.35 59.44C169.331 60.3288 169.653 61.1911 170.25 61.85C170.545 62.1806 170.91 62.4418 171.318 62.6147C171.726 62.7876 172.167 62.868 172.61 62.85C173.214 62.8498 173.81 62.7054 174.347 62.4289C174.885 62.1524 175.349 61.7516 175.7 61.26V63.36C174.816 63.9645 173.771 64.2917 172.7 64.3C172.038 64.3183 171.379 64.2049 170.761 63.9663C170.143 63.7277 169.578 63.3686 169.1 62.91C168.646 62.4674 168.288 61.9365 168.047 61.35C167.806 60.7635 167.688 60.1339 167.7 59.5C167.69 58.8523 167.818 58.2098 168.075 57.6151C168.332 57.0204 168.712 56.487 169.19 56.05C170.054 55.2362 171.17 54.7436 172.353 54.6544C173.536 54.5652 174.714 54.8849 175.69 55.56V55.5Z",
    fill: "url(#paint12_linear_1094_27939)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M185.909 62.9002C184.957 63.8063 183.693 64.3116 182.379 64.3116C181.065 64.3116 179.801 63.8063 178.849 62.9002C178.386 62.4638 178.019 61.9366 177.769 61.3515C177.52 60.7665 177.394 60.1362 177.399 59.5002C177.388 58.8545 177.512 58.2137 177.761 57.6182C178.011 57.0226 178.381 56.4853 178.849 56.0402C179.799 55.1295 181.063 54.6211 182.379 54.6211C183.695 54.6211 184.96 55.1295 185.909 56.0402C186.378 56.4842 186.75 57.0213 186.999 57.6171C187.249 58.2129 187.372 58.8543 187.359 59.5002C187.366 60.1365 187.241 60.7673 186.991 61.3526C186.742 61.9379 186.373 62.4649 185.909 62.9002ZM184.799 57.0302C184.154 56.395 183.285 56.0391 182.379 56.0391C181.474 56.0391 180.604 56.395 179.959 57.0302C179.349 57.6884 179.01 58.5527 179.01 59.4502C179.01 60.3476 179.349 61.212 179.959 61.8702C180.604 62.5053 181.474 62.8613 182.379 62.8613C183.285 62.8613 184.154 62.5053 184.799 61.8702C185.409 61.212 185.748 60.3476 185.748 59.4502C185.748 58.5527 185.409 57.6884 184.799 57.0302Z",
    fill: "url(#paint13_linear_1094_27939)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191.192 55.0905V56.0905C191.428 55.7003 191.764 55.3794 192.164 55.16C192.564 54.9406 193.015 54.8304 193.472 54.8405C194.012 54.8358 194.545 54.9775 195.012 55.2505C195.469 55.5156 195.843 55.9036 196.092 56.3705C196.355 55.8756 196.768 55.4766 197.272 55.2305C197.786 54.9712 198.355 54.8376 198.932 54.8405C200.932 54.8405 201.932 56.1271 201.932 58.7005V64.3105H200.322V58.9605C200.322 58.5805 200.322 58.2705 200.322 58.0205C200.284 57.7367 200.213 57.4582 200.112 57.1905C200.024 56.9092 199.835 56.6705 199.582 56.5205C199.277 56.3505 198.93 56.2708 198.582 56.2905C198.196 56.2756 197.813 56.3729 197.482 56.5705C197.193 56.7528 196.974 57.0278 196.862 57.3505C196.735 57.6722 196.648 58.008 196.602 58.3505C196.55 58.7148 196.526 59.0826 196.532 59.4505V64.3305H195.002V59.0805C195.002 57.2205 194.442 56.2905 193.312 56.2905C192.917 56.2777 192.527 56.3821 192.192 56.5905C191.89 56.7838 191.661 57.0724 191.542 57.4105C191.426 57.7355 191.339 58.0702 191.282 58.4105C191.235 58.782 191.212 59.1561 191.212 59.5305V64.2905H189.602V55.0905H191.192Z",
    fill: "url(#paint14_linear_1094_27939)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1094_27939",
    x1: 154.518,
    y1: 51.9271,
    x2: 157.298,
    y2: 51.9271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1094_27939",
    x1: 156.94,
    y1: 52.8033,
    x2: 158.808,
    y2: 52.7985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1094_27939",
    x1: 159.993,
    y1: 52.7884,
    x2: 161.153,
    y2: 52.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1094_27939",
    x1: 157.732,
    y1: 64.3098,
    x2: 157.732,
    y2: 54.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B90071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B90071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1094_27939",
    x1: 142.879,
    y1: 25.32,
    x2: 184.689,
    y2: 25.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1094_27939",
    x1: 12.83,
    y1: 64.31,
    x2: 12.83,
    y2: 44.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE0811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1094_27939",
    x1: 39.6384,
    y1: 64.3098,
    x2: 39.6384,
    y2: 44.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1094_27939",
    x1: 60.0687,
    y1: 64.3098,
    x2: 60.0687,
    y2: 44.2998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDED00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1094_27939",
    x1: 80.3797,
    y1: 64.3096,
    x2: 80.3797,
    y2: 44.3096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CB236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CB236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1094_27939",
    x1: 101.849,
    y1: 64.3103,
    x2: 101.849,
    y2: 44.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BDE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1094_27939",
    x1: 117.4,
    y1: 64.3096,
    x2: 117.4,
    y2: 31.3496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#006492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006492"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1094_27939",
    x1: 133.811,
    y1: 64.31,
    x2: 133.811,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#846EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#846FA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1094_27939",
    x1: 171.73,
    y1: 64.31,
    x2: 171.73,
    y2: 54.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B90071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B90071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1094_27939",
    x1: 182.379,
    y1: 64.3102,
    x2: 182.379,
    y2: 54.5902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B90071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B90071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1094_27939",
    x1: 195.792,
    y1: 64.3105,
    x2: 195.792,
    y2: 54.8405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B90071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B90071"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMevuelo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mevuelo.7b911d96.svg";
export { ForwardRef as ReactComponent };